export enum SubscriptionEventType {
    AuditLog = "AuditLog",
    OperationStatus = "OperationStatus",
    SyncStatus = "SyncStatus",
    Error = "Error"
}
